module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.service != null) ? _c('div', {
    staticClass: "owl-thumb-item",
    class: {
      'active': _vm.service.selected
    },
    on: {
      "click": _vm.change
    }
  }, [_c('span', {
    staticClass: "media-left"
  }, [_c('i', {
    class: _vm.service.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    domProps: {
      "innerHTML": _vm._s(_vm.service.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.service.subtitle)
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43955b34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/Item.vue
// module id = 360
// module chunks = 0